import { createActions, createReducer } from 'reduxsauce'

import ConsultaVerbasExerciciosAnterioresService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaVerbasExerciciosAnterioresInicio: [],
    buscaConsultaVerbasExerciciosAnterioresErro: ['erro'],
    buscaConsultaVerbasExerciciosAnterioresSucesso: ['consultaVerbasExerciciosAnteriores'],
    limpar: [],
    setConsultaVerbasExerciciosAnterioresEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaVerbasExerciciosAnteriores = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaVerbasExerciciosAnterioresInicio())
        let serv = new ConsultaVerbasExerciciosAnterioresService()
        return serv
            .consultaVerbasExerciciosAnteriores(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaVerbasExerciciosAnterioresSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaVerbasExerciciosAnterioresErro(error)))
    }
}

const buscaConsultaVerbasExerciciosAnterioresInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaVerbasExerciciosAnterioresErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaVerbasExerciciosAnterioresSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaVerbasExerciciosAnteriores.resultado,
        dataSincronizacaoDados: action.consultaVerbasExerciciosAnteriores.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaVerbasExerciciosAnteriores.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaVerbasExerciciosAnterioresEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES_INICIO]: buscaConsultaVerbasExerciciosAnterioresInicio,
    [Types.BUSCA_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES_ERRO]: buscaConsultaVerbasExerciciosAnterioresErro,
    [Types.BUSCA_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES_SUCESSO]: buscaConsultaVerbasExerciciosAnterioresSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_VERBAS_EXERCICIOS_ANTERIORES_ESTADO_DT]: setConsultaVerbasExerciciosAnterioresEstadoDT,
})
